

import service from '../request/index'


// 精品课堂--首页数据
export function getPcourseHomeData () {
  return service({
    url: '/api/course/resource/home/data',
    method: 'GET',
  })
}


// 精品课堂--专题列表
export function getTopicList (data) {
  return service({
    url: '/api/course/resource/title/list',
    method: 'post',
    data: data
  })
}



// 精品课堂--专题分类列表
export function getlabelsList () {
  return service({
    url: '/api/course/resource/title/category',
    method: 'GET',
  })
}


// 精品课堂--课程分类列表
export function getCourseCategory () {
  return service({
    url: '/api/course/resource/course/category',
    method: 'GET',
  })
}


// 精品课堂--课程列表
export function getCourseList (data) {
  return service({
    url: '/api/course/resource/course/list',
    method: 'post',
    data: data
  })
}

// 精品课堂--课程详情
export function getCourseInfo (data) {
  return service({
    url: '/api/course/resource/course/info',
    method: 'GET',
    params: data
  })
}

// 报名学习(免费课程/专题直接调用,如果是付费的不需要调用此接口,直接走支付操作,付费成功会后台自行报名,此接口需要登录)
export function resourceStudy (data) {
  return service({
    url: '/api/course/resource/study',
    method: 'GET',
    params: data
  })
}


// 精品课堂--专题详情
export function getTopicInfo (data) {
  return service({
    url: '/api/course/resource/title/info',
    method: 'GET',
    params: data
  })
}